var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnded)?_c('div',[_vm._v(" Ended. ")]):_c('div',[_c('div',[_vm._v(_vm._s(_vm.duration))])])
}
var staticRenderFns = []

export { render, staticRenderFns }